<template>
  <md-card-content>
    <!-- 法⼈名、支店名 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>法⼈名</label>
      </div>
      <div class="md-layout-item">
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>{{ form.corporation.name }}</label>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>{{ form.corporation.branch_name }}</label>
            </md-field>
          </div>
        </div>
      </div>
    </div>

    <!-- 所在地 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>所在地</label>
      </div>
      <div class="md-layout-item md-size-20 md-small-size-100">
        <md-field>
          <label>〒{{ postalCodeFormat(form.corporation.postal) }}</label>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.corporation.pref }}{{ form.corporation.city }}{{ form.corporation.street_name }}</label>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.corporation.street_number }}</label>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.corporation.etc }}</label>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
      </div>
    </div>

    <!-- ご担当者名 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>ご担当者名</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-50">
        <md-field>
          <label>{{ form.account.name_last }}{{ form.account.name_first }}</label>
        </md-field>
      </div>
    </div>

    <!-- ご連絡先 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>ご連絡先</label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>{{ form.account.email }}</label>
        </md-field>
      </div>
      <div class="md-layout md-layout-item md-alignment-center-left md-size-10 md-small-size-100">
        <label>電話番号</label>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>{{ form.account.tel }}</label>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import CommonMixin from "../../mixins/commonMixin";

export default {
  name  : 'ContractPreviewApply',
  props : ['form'],
  mixins: [CommonMixin],
}
</script>

<style lang="scss" scoped>
</style>
